import { createContext, useContext } from 'react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
var PaginationContext = /*#__PURE__*/createContext();
export var PaginationContextProvider = function PaginationContextProvider(_ref) {
  var currentPage = _ref.currentPage,
      totalPages = _ref.totalPages,
      createPageUrl = _ref.createPageUrl,
      maximumPageNumbersToDisplay = _ref.maximumPageNumbersToDisplay,
      showFirstAndLastArrows = _ref.showFirstAndLastArrows,
      children = _ref.children;
  var first = 1;
  var last = totalPages;
  var previous = currentPage > 1 ? currentPage - 1 : currentPage;
  var next = currentPage < totalPages ? currentPage + 1 : currentPage;
  return _jsx(PaginationContext.Provider, {
    value: {
      currentPage: currentPage,
      totalPages: totalPages,
      first: first,
      last: last,
      previous: previous,
      next: next,
      createPageUrl: createPageUrl,
      maximumPageNumbersToDisplay: maximumPageNumbersToDisplay,
      showFirstAndLastArrows: showFirstAndLastArrows
    },
    children: children
  });
};
export var usePaginationContext = function usePaginationContext() {
  return useContext(PaginationContext);
};